import { render, staticRenderFns } from "./myteams.vue?vue&type=template&id=1df39cd4&"
import script from "./myteams.vue?vue&type=script&lang=js&"
export * from "./myteams.vue?vue&type=script&lang=js&"
import style0 from "./myteams.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports